import React from 'react'
import { CheckCircle, X } from 'lucide-react'
const Info=()=> {
  return (
    <>
      <div className="rounded-md border-l-4 border-green-500 bg-green-100 p-4 relative">
        <div className="flex items-center justify-between space-x-4">
          <div>
            <CheckCircle className="h-6 w-6 text-green-600" />
          </div>
          <div>
            <p className="text-sm font-medium text-green-600">
            Thank you for contacting me
            </p>
          </div>
          <div>
            <X className="h-6 w-6 cursor-pointer text-green-600" />
          </div>
        </div>
      </div>
    </>
  )
}
export default Info
